// extracted by mini-css-extract-plugin
export default {"container":"Root_container__EWrTW","container_withHeader":"Root_container_withHeader__+mf63","content":"Root_content__9cEj9"};